(function ($, document, window) {

    $(document).ready(function () {
        let animated_input = $(".animated-input");

        animated_input.on("mouseover", function (e) {
            AnimateLabel($(this));
        });

        animated_input.on("focus", function (e) {
            AnimateLabel($(this));
        });

        animated_input.on("focusin", function(e) {
            AnimateLabel($(this));
        })

        animated_input.on("mouseout", function (e) {

            // console.log($(this));
            // console.log($(this).children("input").is(":focus"));
            if (!$(this).children("input").is(":focus")) {
                DeanimateLabel($(this));
            }

        });

        animated_input.on("focusout", function (e) {
            DeanimateLabel($(this));
        });
    })

    function AnimateLabel(a_input) {
        a_input.addClass("animated");
    }

    function DeanimateLabel(a_input) {
        if (a_input.children("input").val() === "") {
            a_input.removeClass("animated");
        }
    }

    function AnimatePrefilledInputs() {

    }

}(jQuery, document, window))